import React from 'react';
import classNames from 'classnames';
import { Text } from 'wix-style-react';
import s from './ItemsList.scss';
var MAX_ITEMS_COLUMN = 7;
export var ItemsSection = function (_a) {
    var section = _a.section, showSectionTitle = _a.showSectionTitle;
    var sectionName = section.sectionName, items = section.items;
    var getSplitIndex = function () {
        if (items.length <= MAX_ITEMS_COLUMN) {
            return items.length;
        }
        if (items.length < MAX_ITEMS_COLUMN * 2) {
            return MAX_ITEMS_COLUMN;
        }
        return Math.ceil(items.length / 2);
    };
    var renderColumn = function (_a) {
        var itemsColumn = _a.itemsColumn, dataHook = _a.dataHook, className = _a.className;
        return (React.createElement(Text, { size: "small", className: classNames(s.itemColumn, className), dataHook: dataHook },
            React.createElement("ul", null, itemsColumn.map(function (item, index) { return (React.createElement(Text, { key: item + "-" + index, size: "small", tagName: "li", ellipsis: true, maxWidth: "360px", className: s.item, dataHook: "item" }, item)); }))));
    };
    var splitIndex = getSplitIndex();
    var leftItemsColumn = items.slice(0, splitIndex);
    var rightItemsColumn = items.slice(splitIndex);
    return (React.createElement("div", null,
        showSectionTitle && (React.createElement(Text, { weight: "bold", size: "small", dataHook: "section-title" }, sectionName)),
        React.createElement("div", { className: s.sectionItems },
            renderColumn({
                itemsColumn: leftItemsColumn,
                dataHook: 'left-items-column',
                className: !rightItemsColumn.length ? s.fullWidth : '',
            }),
            !!rightItemsColumn.length &&
                renderColumn({
                    itemsColumn: rightItemsColumn,
                    dataHook: 'right-items-column',
                    className: s.rightColumn,
                }))));
};
//# sourceMappingURL=ItemsSection.js.map